// import React, { useEffect, useState } from "react";

// function CkEditor({ onChange, editorLoaded, name, value }) {
//   const [editor, setEditor] = useState({
//     CKEditor: null,
//     ClassicEditor: null,
//   });

//   useEffect(() => {
//     async function loadEditor() {
//       const { CKEditor } = await import("@ckeditor/ckeditor5-react");
//       const ClassicEditor = (await import("@ckeditor/ckeditor5-build-classic")).default;

//       setEditor({
//         CKEditor,
//         ClassicEditor,
//       });
//     }

//     loadEditor();
//   }, []);

//   const { CKEditor, ClassicEditor } = editor;

//   return (
//     <div>
//       {CKEditor && ClassicEditor ? (
//         <CKEditor
//           name={name}
//           editor={ClassicEditor}
//           config={{
//             ckfinder: {
//               uploadUrl: "" // Enter your upload URL
//             }
//           }}
//           data={value}
//           onChange={(event, editor) => {
//             const data = editor.getData();
//             onChange(data);
//           }}
//         />
//       ) : (
//         <div>Editor loading...</div>
//       )}
//     </div>
//   );
// }

// export default CkEditor;
import React, { useEffect, useState, useMemo } from 'react';

function CkEditor({ onChange, editorLoaded, name, value }) {
  const [editor, setEditor] = useState({
    CKEditor: null,
    ClassicEditor: null,
  });

  useEffect(() => {
    let isMounted = true;

    async function loadEditor() {
      try {
        const { CKEditor } = await import('@ckeditor/ckeditor5-react');
        const ClassicEditor = (
          await import('@ckeditor/ckeditor5-build-classic')
        ).default;

        if (isMounted) {
          setEditor({
            CKEditor,
            ClassicEditor,
          });
        }
      } catch (error) {
        console.error('Failed to load CKEditor:', error);
      }
    }

    loadEditor();

    return () => {
      isMounted = false;
    };
  }, []);

  const { CKEditor, ClassicEditor } = editor;

  const safeValue = useMemo(() => {
    return value ?? '';
  }, [value]);

  return (
    <div>
      {CKEditor && ClassicEditor ? (
        <CKEditor
          name={name}
          editor={ClassicEditor}
          config={{
            ckfinder: {
              uploadUrl: '',
            },
          }}
          data={safeValue}
          onChange={(event, editorInstance) => {
            const data = editorInstance?.getData?.() ?? '';
            if (typeof onChange === 'function') {
              onChange(data);
            }
          }}
        />
      ) : (
        <div>Editor loading...</div>
      )}
    </div>
  );
}

export default CkEditor;
